import { ReactNode, useMemo } from 'react';
import { FilterField, ListFiltersBar } from '../../components/ListFiltersBar';
import { Select } from '../../components/ui';
import { t } from '../../i18n';

export function buildMydataYearOptions(now = new Date()) {
  const current = now.getFullYear();
  return [current - 1, current, current + 1].map((y) => ({
    value: String(y),
    label: String(y),
  }));
}

export function MydataYearFilterBar({
  year,
  onYearChange,
  actions,
  children,
  className,
}: {
  year: number;
  onYearChange: (year: number) => void;
  actions?: ReactNode;
  children?: ReactNode;
  className?: string;
}) {
  const labels = t().mydata;
  const yearOptions = useMemo(() => buildMydataYearOptions(), []);

  return (
    <ListFiltersBar actions={actions} className={className}>
      <FilterField label={labels.yearLabel} className="max-w-[10.5rem]">
        <Select
          size="sm"
          value={String(year)}
          onChange={(e) => onYearChange(Number(e.target.value))}
          options={yearOptions}
        />
      </FilterField>
      {children}
    </ListFiltersBar>
  );
}
